<template>
  <div class="sign-up-background-panel row">
    <div class="flow-panel">
      <img src="@/assets/static/img/plyo-logo.svg">
      <transition name="fade" mode="out-in">
        <getting-started v-if="flow_step === 'getting started'" v-on:goTo="goTo"/>
      </transition>
      <transition name="fade" mode="out-in">
        <create-account v-if="flow_step === 'create account'" :email="flow_payload.email" v-on:goTo="goTo" />
      </transition>
    </div>
    <div class="encouragement-panel">
      <div class="encouragement-container">
        <transition name="fade" mode="out-in">
          <getting-started-encouragement v-if="flow_step === 'getting started'" />
        </transition>
        <transition name="fade" mode="out-in">
          <create-account-encouragement v-if="flow_step === 'create account'" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import GettingStarted from '@/components/SignUp/Views/Flow/GettingStarted.vue'
  import CreateAccount from '@/components/SignUp/Views/Flow/CreateAccount.vue'

  import GettingStartedEncouragement from '@/components/SignUp/Views/Encouragement/GettingStartedEncouragement.vue'
  import CreateAccountEncouragement from '@/components/SignUp/Views/Encouragement/CreateAccountEncouragement.vue'

  export default {
    components: {
      GettingStarted,
      CreateAccount,
      GettingStartedEncouragement,
      CreateAccountEncouragement,
    },
    data () {
      return {
        flow_step: 'getting started',
        flow_payload: {},
      }
    },
    methods: {
      goTo(payload) {
        this.flow_payload.email = payload.email;
        this.flow_step = '';
        const self = this;
        setTimeout(function () { 
            self.flow_step = payload.step;
          }, 100);
      },
    },
  }
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
